import React, { useRef } from 'react';
import { useIsDesktop } from '../../../Utils/productPageUtils';
import GlobalStyle from '../../../styles/globalStylesV2';
import { babyTextData, titleImageMapping, titleMappingMob } from '../constant';
import BabyCareSection from './BabyCareSection';
import StaggeredGrid from './StaggeredGrid';

const ExpandedCategory = (props) => {
  const { categoryData } = props;
  const r = useRef();
  const isDesktop = useIsDesktop();
  const manipulatedData = (
    categoryData,
    index,
    mobile,
    emptyCount,
    indexToinsert,
    imgUrl,
  ) => {
    let data = categoryData[index];
    let subCategories = [];
    for (let i = 0; i < emptyCount; i++) {
      subCategories.push({ cardImg: '' });
    }

    subCategories = [
      ...subCategories,
      ...data.subCategories.map((cat) => {
        return {
          text: cat.tabName,
          cardImg: mobile
            ? titleMappingMob[cat?._id]
            : titleImageMapping[cat?._id],
          totalProducts: cat.totalProducts,
          key: cat.key,
        };
      }),
    ];
    let catData = { ...babyTextData, cards: subCategories };
    // console.log(catData);
    catData['cards']?.splice(indexToinsert, 0, {
      cardImg: imgUrl,
    });
    return [catData];
  };
  const babycare = !isDesktop
    ? manipulatedData(
        categoryData,
        2,
        true,
        1,
        1,
        'https://images.myloapp.in/NestJsUploads/1697657524002-Group.webp',
      )
    : manipulatedData(
        categoryData,
        2,
        false,
        2,
        3,
        'https://images.myloapp.in/NestJsUploads/1697951417763-MicrosoftTeams-image-(15).webp',
      );

  return (
    <>
      <GlobalStyle />
      <StaggeredGrid categoryData={categoryData} />

      {babycare.map((gridData, index) => {
        return (
          <BabyCareSection
            sectionClass={'section2'}
            key={`sec3_${index}`}
            gridData={gridData}
            second={true}
          />
        );
      })}
    </>
  );
};

export default ExpandedCategory;
